
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class HttpService {
  constructor(private http: HttpClient) { }
  getById(path: string, id: any) {
    return this.http.get(`${environment.apiUrl}/${path}/${id}`);
  }
  create(path: string, body: any) {
    return this.http.post(`${environment.apiUrl}/${path}`, body);
  }
  update(path: string, id: string, body: any) {
    return this.http.put(`${environment.apiUrl}/${path}/${id}`, body);
  }
  delete(path: string, id: any) {
    return this.http.delete(`${environment.apiUrl}/${path}`);
  }
  list(path: string, params: any) {
    return this.http.get(`${environment.apiUrl}/${path}`, { params });
  }
  entityPost(path: string, body: any) {
    return this.http.post(`${environment.mlApi}/${path}`, body);
  }
  snapShot(id: string) {
    return this.http.get(`${environment.apiUrl}/companies/${id}/snapshot`);
  }
  getId(path: string) {
    return this.http.get(`${environment.scraperApi}/${path}`);
  }
  companyData(id: string) {
    return this.http.get(`${environment.apiUrl}/companies/${id}`);
  }
}
